<template>
  <div>
    <div class="content-form-calification">
      <div class="header d-flex justify-content-between">
        Controles
        <div class="pr-3" id="tooltip-button-control">
          <img
            src="@/assets/images/icons/icon-matriz-iper/icon-warning.png"
            alt=""
          />
        </div>
      </div>
      <form class="mt-5" @submit.prevent="saveData">
        <div class="row">
          <b-col cols="12" class="mb-5">
            <Textarea
              label="Fuente"
              name="source_control"
              placeholder="Descripción del control en la fuente."
              :rows="'3'"
              :value="formData.source_control"
              @input="(event) => (formData.source_control = event.target.value)"
            />
          </b-col>
          <b-col cols="12" class="mb-5">
            <Textarea
              label="Medio"
              name="environment_control"
              placeholder="Descripción del control en el medio."
              :rows="'3'"
              :value="formData.environment_control"
              @input="
                (event) => (formData.environment_control = event.target.value)
              "
            />
          </b-col>
          <b-col cols="12" class="mb-5">
            <Textarea
              label="Persona"
              name="individual_control"
              placeholder="Descripción del control en el individuo."
              :rows="'3'"
              :value="formData.individual_control"
              @input="
                (event) => (formData.individual_control = event.target.value)
              "
            />
          </b-col>
        </div>
        <div class="d-flex justify-content-center mb-4">
          <button
            class="button_primary"
            type="submit"
            :disabled="isBusy || isDisabled"
          >
            <b-spinner v-if="isBusy" />
            Guardar cambios
          </button>
        </div>
      </form>
    </div>
    <b-tooltip
      target="tooltip-button-control"
      placement="left"
      custom-class="custom-tooltip-ht"
    >
      Los controles están definidos como todas aquellas acciones y/o decisiones
      tomadas en pro de la mejora de las condiciones de la actividad.
    </b-tooltip>
  </div>
</template>

<script>
import useInputs from "@/components/general/Inputs";
const { Input, Textarea, Select } = useInputs();
export default {
  components: {
    Input,
    Textarea,
    Select,
  },
  props: {
    isBusy: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      formData: {
        source_control: "",
        environment_control: "",
        individual_control: "",
      },
    };
  },
  watch: {
    record() {
      const me = this;
      if (me.record) me.loadData();
    }
  },
  computed: {
    isDisabled() {
      const me = this;
      const isDisabled =
        me.formData.source_control === "" ||
        me.formData.environment_control === "" ||
        me.formData.individual_control === ""
          ? true
          : false;
      return isDisabled;
    },
  },
  methods: {
    saveData() {
      const me = this;
      me.$emit("saveData", {
        source_control: me.formData.source_control,
        environment_control: me.formData.environment_control,
        individual_control: me.formData.individual_control,
      });
    },
    async loadData() {
      const me = this;
      me.formData.source_control = me.record?.source_control || "";
      me.formData.environment_control = me.record?.environment_control || "";
      me.formData.individual_control = me.record?.individual_control || "";
    }, 
  },
  mounted() {
    const me = this;
    if (me.record) me.loadData();
  }
};
</script>

<style lang="css">
.content-form-calification {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
}
.content-form-calification .header {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  background-color: #eceff1 !important;
  padding-left: 10px;
}
</style>
